var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    className: "w-6 h-6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    id: 4,
    strokeLinejoin: "round",
    d: "M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0",
    stroke: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    id: 3,
    strokeLinejoin: "round",
    d: "M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0",
    stroke: "gray"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    id: 2,
    strokeLinejoin: "round",
    d: "M8.288 15.038a5.25 5.25 0 0 1 7.424 0",
    stroke: "gray"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    id: 1,
    strokeLinejoin: "round",
    d: "M12.53 18.22l-.53.53-.53-.53a.75.75 0 0 1 1.06 0",
    stroke: "#7CFC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.ddb94753ffdca93ce892c1867341ed6e.svg";
export { ForwardRef as ReactComponent };